import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from 'ui-component/Loader';

const AuthGuard = ({ children }) => {
    const { isLoggedIn, isInitialized } = useSelector((state) => state.account);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isInitialized) return;
        if (!isLoggedIn) navigate('/login', { replace: true });
    }, [isLoggedIn, isInitialized, navigate]);

    if (!isInitialized) {
        return <Loader />;
    }
    if (!isLoggedIn) {
        return null;
    }
    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;
